import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { newCreateConsultSteps } from './CreateConsultationSteps.data';
import StepWizard from '../../../commons/StepWizard/StepWizard';
import { useConsultationSummary } from '../../../../hooks/fetchers/useConsultationSummary/useConsultationSummary';
import Loading from '../../../commons/Loading/Loading';
import { useEffect, useMemo, useState } from 'react';
import Empty from '../../../commons/Empty/Empty';

export default () => {
  const { consultationId } = useParams();
  const [searchParams] = useSearchParams();

  const [duplicate] = useMemo(
    () => [searchParams.get('duplicate')],
    [searchParams]
  );

  const navigate = useNavigate()

  const [defaultStep, setDefaultStep] = useState<number>()

  // useEffect(() => {
  //   if (Boolean(duplicate)) {
  //     setDefaultStep(1)
  //   } 
  // }, [duplicate])

  const { data, isLoading, error } = useConsultationSummary(parseInt(consultationId as string), {
    retry: false,
    refetchOnWindowFocus: false,
    enabled: Boolean(consultationId),
    cacheTime: 0,
  });

  useEffect(() => {
    if (data) {
      if (data.infos.id_step === 4) {
        navigate(`/dashboard/consultations/${data.infos.id}`);
      } else if (duplicate) {
        setDefaultStep(1)
      }  else {
        setDefaultStep(data.infos.id_step + 1)
      }
    }
  }, [data, duplicate]);

  if (isLoading) return <Loading />;

  if (error) return <Empty>{error.message}</Empty>;

  return (
    <StepWizard
      steps={newCreateConsultSteps}
      logoLink="/portal/dashboard"
      {...(data && consultationId && { defaultStep })}
    />
  );
};
